<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-8 relative">
    <SCardsWide
      v-for="(card, idx) in cards"
      :key="idx"
      v-bind="card"
      class="w-full"
    />
  </div>
</template>

<script setup lang="ts">
import type { SCardsWideProps } from './index.vue'

export interface SCardsWideWrapperProps {
  cards: SCardsWideProps[]
}

defineProps<SCardsWideWrapperProps>()
</script>
